import { MONTHS_SHORT } from './format';

/**
 * Lot AJ : cloche des notifications de l'en-tête (logique pure, testée).
 */

/** Nombre de notifications affichées dans le panneau de la cloche (« Tout voir » mène aux 50 dernières). */
export const BELL_LIMIT = 8;

/** Pastille de la cloche : rien à 0, « 99+ » au-delà de 99. */
export function bellBadge(unread: number): string | null {
  if (unread <= 0) return null;
  return unread > 99 ? '99+' : String(unread);
}

/** Libellé accessible de la cloche : « Notifications, 3 non lues ». */
export function bellLabel(unread: number): string {
  if (unread <= 0) return 'Notifications, aucune non lue';
  return `Notifications, ${unread} non lue${unread > 1 ? 's' : ''}`;
}

/** « à l'instant », « il y a 12 min », « il y a 3 h », « hier », « il y a 4 j », puis « 3 oct. ». */
export function notificationAge(createdAt: string, now: Date = new Date()): string {
  const at = new Date(createdAt);
  const minutes = Math.floor((now.getTime() - at.getTime()) / 60_000);
  if (minutes < 1) return "à l'instant";
  if (minutes < 60) return `il y a ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `il y a ${hours} h`;
  const days = Math.floor(hours / 24);
  if (days === 1) return 'hier';
  if (days < 7) return `il y a ${days} j`;
  const [, month, day] = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris' })
    .format(at)
    .split('-')
    .map(Number);
  return `${day === 1 ? '1er' : day} ${MONTHS_SHORT[(month ?? 1) - 1]}`;
}

/** Chemin à ouvrir au clic : seulement un chemin interne de l'appli (jamais une adresse externe). */
export function notificationTarget(url: string | null): string | null {
  if (!url || !url.startsWith('/') || url.startsWith('//')) return null;
  return url;
}
